import { render, staticRenderFns } from "./NavSettings.vue?vue&type=template&id=5c5a0210&scoped=true"
import script from "./NavSettings.vue?vue&type=script&lang=js"
export * from "./NavSettings.vue?vue&type=script&lang=js"
import style0 from "./NavSettings.vue?vue&type=style&index=0&id=5c5a0210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a0210",
  null
  
)

export default component.exports